// @flow
import React from "react";

import "./cctvIcon.scss";
import Cctv from "../../../svg/facilities/has_cctv.svg";

const CctvIcon = () => <Cctv className="c-cctv-icon" />;

export default CctvIcon;
